import { useEffect } from "react";
import { TFormHookParams, IFormSection } from "../../types/common";
import useSearchOptions from "../common/useSearchOptions";
import {
  addSelectItem,
  getRegister,
  userSelectItem,
} from "../../utils/helpers";
import useGet from "../common/useGet";
import { API_STAFF_WAGES, API_USERS, API_STAFF_TYPE } from "../../utils/apis";
import { URL_STAFF_WAGES } from "../../utils/urls";

const useStaffWagesForm = ({ id, form }: TFormHookParams = {}) => {
  const isUpdate = !!id;
  const supervisors = useSearchOptions({
    api: API_USERS,
    searchParam: "first_name",
    params: { role_name: form?.role },
    toOption: userSelectItem,
  });

  const {
    loadData: getStaffTypes,
    data: staffTypes,
    loading: loadingStaffTypes,
  } = useGet();

  useEffect(() => {
    getStaffTypes({ api: API_STAFF_TYPE });
  }, []);

  const sections: IFormSection[] = [
    {
      title: "Staff Wages Details",
      fields: [
        {
          field_name: "role",
          type: "select",
          label: "Staff Type",
          // props: {
          //   required: true,
          //   disabled: isUpdate,
          // },
          // options_data: [
          //   addSelectItem({ label: "Agent", value: "Agent" }),
          //   addSelectItem({ label: "Enforcement", value: "Enforcement" }),
          //   addSelectItem({ label: "Supervisor", value: "Supervisor" }),
          // ],
          options_data: staffTypes?.map((type: any) =>
            addSelectItem({ label: type.name, value: type.id }),
          ),
          loading: loadingStaffTypes,
          value: form?.role,
        },
        {
          field_name: "user",
          type: "select",
          label: "User",
          props: {
            required: true,
            disabled: isUpdate,
          },
          search: supervisors,
          value: form?.supervisors,
        },
        {
          field_name: "phone_number",
          type: "tel",
          label: "Phone Number",
          props: {
            required: true,
          },
          value: form?.phone_number,
        },

        {
          field_name: "custom_fixed_wage",
          type: "number",
          label: "Custom Fixed Wage",
          props: {
            required: true,
          },
          value: form?.custom_fixed_wage,
          visible: form?.role === "Supervisor",
        },
        {
          field_name: "is_active",
          label: "Status",
          type: "select",
          props: {
            required: isUpdate ? false : true,
            options: [
              { value: true, label: "Active" },
              { value: false, label: "Inactive" },
            ],
          },
        },
      ],
    },
  ];

  const title = "Staff Wages";
  const redirect = getRegister(URL_STAFF_WAGES);

  const onSubmit = (payload: any) => {
    if (id) {
      return {
        id,
        api: API_STAFF_WAGES,
        params: {
          ...payload,
        },
      };
    }
    return {
      api: API_STAFF_WAGES,
      params: {
        ...payload,
      },
    };
  };

  return {
    sections,
    onSubmit,
    title,
    redirect,
  };
};

export default useStaffWagesForm;
